import React from "react";
import { useTranslation } from "react-i18next";
import { LicensePlateSelectField } from "../LicensePlateSelectField";

interface LicensePlateSelectionProps {
  selectedLicense: string | null;
  isCustomLicense: boolean;
  onLicensePlateChange: (license: string | null, isCustom: boolean) => void;
}

export const LicensePlateSelection: React.FC<LicensePlateSelectionProps> = ({
  selectedLicense,
  isCustomLicense,
  onLicensePlateChange,
}) => {
  const { t } = useTranslation("common");

  return (
    <>
      <div className="mt-3">
        <label className="form-label fw-bold">{t("License plate")}</label>
        <div className="mb-2">
          <small className="text-muted">
            {t(
              "Start typing to search existing cars, or enter a new 6+-character license plate",
            )}
          </small>
        </div>
        <LicensePlateSelectField
          value={selectedLicense}
          onChange={onLicensePlateChange}
          placeholder={t("Type or select a license plate (6+ characters)...")}
        />
      </div>

      {selectedLicense && isCustomLicense && (
        <div className="alert alert-info mt-2" role="alert">
          <div className="d-flex align-items-center">
            <i className="fas fa-info-circle me-2"></i>
            <div>
              <strong>{t("New car detected")}</strong>
              <div>
                {t(
                  "This license plate is not in our system yet. We'll create a new car record.",
                )}
              </div>
              <div className="mt-1">
                <small className="text-muted">
                  {t(
                    "Note: New cars can only be picked up initially (delivery available after first pickup)",
                  )}
                </small>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
